import { state } from '@angular/animations';
import {
  Action,
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createReducer,
  createSelector,
  MetaReducer,
  on,
  Store
} from '@ngrx/store';
import { environment } from 'src/environments/environment';
import * as AuthActions from '../../redirect/redirect.actions';
import * as headerAction from '../../shared/header.actions';
import * as AppAction from '../../app.actions';

export const redirectFeatureKey = 'userinfo';

export interface State {
  UUID: string;
  UserName: string;
  MSISDN: string;
  SubscriberType: string;
  Email: string;
  DisplayName: string;
  UserTier: string;
  GC: number;
  RP: number;
  Roles: string[];
}

export const initialState: State = {
  UUID: null,
  UserName: null,
  MSISDN: null,
  SubscriberType: null,
  Email: null,
  DisplayName: null,
  UserTier: null,
  GC: null,
  RP: null,
  Roles: []
};

const authReducer = createReducer(
  initialState,
  on(AuthActions.authenticationSuccess, (userinfoState, action) => ({
    ...userinfoState,
    ...action.data
  })),
  on(headerAction.confirmSuccessful, (userinfoState, action) => ({
    ...userinfoState,
    ...action.data
  })),
  on(AppAction.getUserInfoSuccess, (userinfoState, action) => ({
    ...userinfoState,
    ...action.data
  })),
  on(headerAction.signOutSuccessful, (userInfoState, action) => ({
    ...userInfoState,
    ...initialState
  }))
);

export function reducer(userinfoState: State | undefined, action: Action) {
  return authReducer(userinfoState, action);
}

export const selectUserInfo =
createFeatureSelector<State>(redirectFeatureKey);

export const selectIsAuth = createSelector(
  selectUserInfo,
  (userInfoState: State) => !!userInfoState.UUID
);

export const selectGC = createSelector(
  selectUserInfo,
  (userInfoState: State) => userInfoState.GC
);

export const selectRP = createSelector(
  selectUserInfo,
  (userInfoState: State) => userInfoState.RP
);

// export const reducers: ActionReducerMap<State> = {

// };


export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
